export default __webpack_public_path__ + "static/media/placeholder_store03-fr-web.736e94dc.png";